import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import {
  useGetChannelsListQuery,
  useEditChannelMutation
} from '@/api/channels';
import { useSelector } from "react-redux";
import { selectActiveBuildingId } from "@/features/building/buildingSlice";
import { useTranslation } from 'react-i18next';
import WidgetPaper from '@/components/WidgetPaper'

const GORKY_CHANNEL_ID = '8d6b8184-4ca4-4891-af2d-9b2757b27da1';
const GORKY_BUILDING_ID = 158;

const GorkyToggle = () => {
  const { t } = useTranslation()
  const activeBuildingId = useSelector(selectActiveBuildingId)
  if (activeBuildingId !== GORKY_BUILDING_ID) return null;
  const { data: allChannels } = useGetChannelsListQuery(undefined)
  const [editChannel] = useEditChannelMutation()
  const gorkyChannel = allChannels?.find((ch) => ch.id === GORKY_CHANNEL_ID)
  
  const handleGorkyToggle = async () => {
    if (!gorkyChannel) return
    try {
      await editChannel({
        id: gorkyChannel.id,
        building_id: gorkyChannel.building_id,
        name: gorkyChannel.name,
        is_active: !gorkyChannel.is_active,
        metadata: gorkyChannel.metadata,
        type: gorkyChannel.type
      }).unwrap()
    } catch (err) {
      console.error('toggle gorky error:', err)
    }
  }
  return (
    <WidgetPaper title={t('widgets_gorky_title')}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant="body2" sx={{
          color: "text.secondary"
        }}>
          {gorkyChannel?.is_active
            ? '✅ Въезд открыт'
            : '🔴 Въезд закрыт'}
        </Typography>
        <Tooltip
          title={
            gorkyChannel?.is_active
              ? 'Нажмите чтобы закрыть въезд'
              : 'Нажмите чтобы открыть въезд'
          }
        >
          <Switch
            checked={gorkyChannel?.is_active ?? false}
            color="success"
            onChange={handleGorkyToggle}
          />
        </Tooltip>
      </Box>
    </WidgetPaper>
  );
}

export default GorkyToggle;